import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectImprovementsField, {
  MxFormSelectImprovementsFieldProp
} from "@rf-l2/form/select/MxFormSelectImprovementsField";

export interface MxFormL3ImprovementsFieldProps
  extends MxFormSelectImprovementsFieldProp {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3ImprovementsField = (props: MxFormL3ImprovementsFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectImprovementsField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3ImprovementsField;
